import React from 'react'
import styled from 'styled-components'

import { useLocation } from 'react-router'
import { Location } from 'history'

import { routes } from '../../routes'
import { StyledLinkButton } from './SocialSignIn.styles'
import { ReactComponent as Shield } from '@sketch/icons/img-sso-logo-17'

export const ShieldIcon = styled(Shield)`
  width: 17px;
  height: 17px;
`

interface LocationState {
  from?: Location
}

interface ContinueWithSSOProps {
  redirectTo?: string
}

export const ContinueWithSSO = ({ redirectTo }: ContinueWithSSOProps) => {
  const location = useLocation<LocationState>()

  return (
    <StyledLinkButton
      size="40"
      variant="secondary"
      to={{
        pathname: routes.SSO_SIGN_IN.create({}),
        state: {
          from: location.state?.from,
          externalRedirectUrl: redirectTo,
        },
      }}
      icon={() => <ShieldIcon />}
    >
      Continue with SSO
    </StyledLinkButton>
  )
}
